var map = {
	"./CmsMenu": [
		13642,
		3642
	],
	"./CmsMenu.tsx": [
		13642,
		3642
	],
	"./InfoMenu": [
		56351,
		6351
	],
	"./InfoMenu.tsx": [
		56351,
		6351
	],
	"./MyPagesMenu": [
		67171,
		7171
	],
	"./MyPagesMenu.tsx": [
		67171,
		7171
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1210;
module.exports = webpackAsyncContext;